<template>
    <section class="footer-wrapper">
        <footer class="container">
            <div class="paragraph" data-aos="fade-up">
                <img src="@/assets/img/logo_bk.png" alt="Bombay Shapphire">
                <h3>世界中の人々に愛され、<br>選ばれ続けている世界No.1プレミアムジン*</h3>
                <p>
                    1761年から続く伝統的なレシピ、世界中から厳選されたボタニカル、<br>
                    そして独自のヴェイパー・インフュージョン製法によって作り出される<br>
                    洗練された味わいと香りのロンドン・ドライ・ジン。<br>
                    *2019年1～12月販売量・金額において（IWSR社調べ）
                </p>
                <span class="copyright hideSp">
                    &copy;2018 Bombay Sapphire is a trademark, all rights reserved.
                </span>
            </div>
            <div class="img-box">
                <img class="bottle" data-aos="fade-left" src="@/assets/img/bottle.png" alt="Sales in Amazon">
                <a href="https://www.amazon.co.jp/stores/page/87BC8E57-71F4-423F-A848-57949CB4742C?ingress=0&visitId=69393c83-c848-4625-a5e9-349f4758a97f&lp_slot=auto-sparkle-hsa-tetris&store_ref=SB_A21D9RE12HVCS3&ref_=sbx_be_s_sparkle_td_brand" 
                    target="_blank" class="amazon" data-aos="fade-left" data-aos-delay="200">
                    <img :src="Amazon" alt="">
                </a>
            </div>
            <span class="copyright hidePc">
                    &copy;2018 Bombay Sapphire is a trademark, all rights reserved.
            </span>
        </footer>
    </section>
</template>

<script>
import amazon from '@/assets/img/btn-amazon.svg'

export default {
    components:{
        
    },
    data(){
        return{
            Amazon: Object
        }
    },
    created(){
        this.Amazon = amazon
    }
}
</script>

<style lang="scss" scoped>
    .footer-wrapper{
        background: $gradient;
        min-height: 870px;
        @media #{$maxL}{
            height: auto;
        }
        @media #{$maxL}{
            min-height: 0;
        }
        footer.container{
            @extend %flex;
            flex-flow: row nowrap;
            align-items: center;
            height: calc(100% - 240px);
            @media #{$maxL}{
                flex-flow: column;
                align-items: center;
                justify-content: center;
            }
            .copyright{
                width: 100%;
                text-align: left;
                font-family: $Times;
                font-size: 1em;
                font-weight: 300;
                display: block;
                margin-top: 30px;
                @media #{$maxL}{
                    font-size: 10px;
                    text-align: center;
                    margin-top: 42px;
                }
            }
            .paragraph{
                width: 65%;
                height: 100%;
                margin-right: 40px;
                @extend %flex;
                z-index: 1;
                @media #{$maxL}{
                    width: 100%;
                    margin-right: 0;
                }
                h3{
                    font-size: 2.37vw;
                    margin-top: 42px;
                    margin-bottom: 42px;
                    width: 100%;
                    white-space: nowrap;
                    @media #{$minMax}{

                    }
                    @media #{$minXL}{
                        font-size: 36px;
                    }
                    @media #{$maxL}{
                        font-size: 4vw;
                        text-align: center;
                    }
                    @media #{$maxM}{
                        text-align: center;
                        margin: 20px 0;
                        font-size: 15px;
                    }
                }
                p{
                    width: 100%;
                    font-size: 1.6vw;
                    margin-top: 0;
                    line-height: 2.328em;
                    @media #{$minXL}{
                        font-size: 1.246em;
                    }
                    @media #{$maxL}{
                        text-align: center;
                        margin-bottom: 40px;
                    }
                    @media #{$maxM}{
                        font-size: 10px;
                        margin-bottom: 40px;
                    }
                }
                img{
                    height: 6em;
                    width: auto;
                    @media #{$maxL}{
                        height: auto;
                        width: 70%;
                        @media #{$maxL}{
                            height: 100%;
                        }
                    }
                }
            }
            .img-box{
                @extend %flex;
                width: 40%;
                height: 100%;
                position: relative;
                align-items: flex-start;
                @media #{$maxL}{
                    width: 100%;
                    align-items: center;
                }
                .bottle{
                    width: 50%;
                    height: auto;
                    //margin-right: 20%;
                    @media #{$maxL}{
                        width: 30%;
                        height: auto;
                    }
                    @media #{$IE}{
                        width: auto;
                        height: auto;
                        max-width: 252px;
                        max-height: 550px;
                    }
                }
                .amazon{
                    width: 40%;
                    height: auto;
                    min-width: 180px;
                    min-height: 100px;
                    position: absolute;
                    transform: translateY(-50%);
                    top: 50%;
                    right: 0;
                    @media #{$maxL}{
                        width: 15%;
                        min-width: 120px;
                        min-height: 0;
                        top: unset;
                        bottom: 0;
                    }
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }

    }
</style>